<template>
  <div>
    <app-cells><h1 class="title">Authorization forms</h1></app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'AuthorizationFormsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'authorization-forms-pending', label: 'Pending', roles: [] },
        { name: 'authorization-forms-charged', label: 'Charged', roles: ['general_manager', 'finance_manager'] },
      ],
      tabs_to_show: [],
    }
  },
  created() {
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = tabs
  }
}
</script>
